import { jsx as _jsx } from "react/jsx-runtime";
import { ShortUrlObjectType } from "@air/api/types";
import { SharePublicItemModal } from "../SharePublicItemModal";
export const SharePublicBoardModal = (props)=>{
    return /*#__PURE__*/ _jsx(SharePublicItemModal, {
        ...props,
        type: ShortUrlObjectType.board
    });
};
